import { z } from 'zod';
import { match } from 'ts-pattern';

import { Countries } from '~/common/constants/countries.enum';

const USA_ZIP_CODE_REGEX = /^\d{5}$/;
const CANADA_POSTAL_CODE_REGEX = /^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/;

const regexCountry = {
  [Countries.US]: USA_ZIP_CODE_REGEX,
  [Countries.CA]: CANADA_POSTAL_CODE_REGEX,
};

const getZipCodeSchema = (country: Countries, errorMessage?: string) =>
  z.string().regex(regexCountry[country], errorMessage);

const sanitizeZipCode = (value: string, country: Countries): string =>
  match(country)
    .with(Countries.CA, () =>
      value.toUpperCase().replace(/[^A-Z0-9 ]/g, '').replace(/\s+/g, ' ').slice(0, 7)
    )
    .otherwise(() => value.replace(/\D/g, '').slice(0, 5));

export { USA_ZIP_CODE_REGEX, CANADA_POSTAL_CODE_REGEX, getZipCodeSchema, sanitizeZipCode };
